export const SET_GENERIAL_FETCHING_FILTER = 'SET_GENERIAL_FETCHING_FILTER';
export const SET_GENERIAL_FILTER_BOX_SUCCESS = 'SET_GENERIAL_FILTER_BOX_SUCCESS';
export const SET_GENERIAL_FILTER_BOX_ERROR = 'SET_GENERIAL_FILTER_BOX_ERROR';